import { z } from "zod/mini"

const BooleanConfigSchema = z.object({
	label: z.nullish(z.string()),
	default_value: z.optional(z.boolean()),
	placeholder_true: z.optional(z.string()),
	placeholder_false: z.optional(z.string()),
})

export const BooleanModelSchema = z.object({
	type: z.literal("Boolean"),
	config: z.optional(BooleanConfigSchema),
})

export type BooleanModel = z.infer<typeof BooleanModelSchema>
